var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[(_vm.notification)?_c('NotificationDetail',{attrs:{"notification":_vm.notification,"loadingNotification":_vm.loadingNotification,"isSharedAccess":true}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }